var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function({on}){return [_c('v-text-field',_vm._g({attrs:{"hide-details":"","label":_vm.label,"solo":"","outlined":"","flat":"","dense":"","append-icon":"mdi-calendar-range","readonly":""}},on))]}}])},[_c('v-date-picker',{attrs:{"no-title":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }